export default __webpack_public_path__ + "static/media/loader.5dd9e256.gif";